query GetDataUpload($id: ID!) {
  dataUpload(id: $id) {
    id
    uploadType
    status
    totals {
      totalRows
      errors
      potentialDuplicates
      ready
      created
    }
    errorMessage
    user {
      id
      name
    }
    createdAt
    updatedAt
  }
}
